export default "__VITE_ASSET__gpU1Ar2f__"